import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.some";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.filter";
import _toConsumableArray from "/tmp/project/zhsh/ysa-IntegratedServiceSaas_webTMP/home/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/tmp/project/zhsh/ysa-IntegratedServiceSaas_webTMP/home/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.array.some";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.is-array";
import _defineProperty from "/tmp/project/zhsh/ysa-IntegratedServiceSaas_webTMP/home/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import service from "./request";
import Layout from '@/layout';
import Layout2 from '@/layout/index2';
import store from '@/store';
import { constantRoutes } from '@/router/index';
import { pro } from '@/utils/settings';

// 供应商路由对应组件
export var supplierManagementRouterComponents = {
  // supplierManagement: () => import('@/views/supplier/supplierManagement'), // 供应商管理
  // addSupplier: () => import('@/views/supplier/addSupplier'), // 新增供应商
  // supplierCooperation: () => import('@/views/supplier/supplierCooperation'), // 供应商合作协议
  providerManagement: function providerManagement() {
    return import('@/views/supplier/providerManagement');
  } // 服务商管理
};
// 系统管理路由对应组件
export var systemManagementRouterComponents = {
  permission: function permission() {
    return import('@/views/system/permission');
  },
  // 菜单管理
  onlineRegistration: function onlineRegistration() {
    return import('@/views/system/onlineRegistration');
  },
  // 在线注册
  helpDocument: function helpDocument() {
    return import('@/views/system/helpDocument');
  },
  // 帮助文档
  parameterSet: function parameterSet() {
    return import('@/views/system/parameterSet');
  },
  // 参数配置
  laboratory: function laboratory() {
    return import('@/views/system/laboratory');
  },
  // 实验室管理
  instrumentBasic: function instrumentBasic() {
    return import('@/views/system/instrumentBasic');
  },
  // 仪器基础管理
  instrumentList: function instrumentList() {
    return import('@/views/system/instruManage/instrumentList');
  },
  // 仪器基础管理
  customProcessList: function customProcessList() {
    return import('@/views/system/customProcessList');
  },
  // 自定义审批
  customApproval: function customApproval() {
    return import('@/views/system/customApproval');
  },
  // 自定义审批
  organization: function organization() {
    return import('@/views/system/organization');
  },
  // 部门管理
  roleManage: function roleManage() {
    return import('@/views/system/role');
  },
  // 角色管理
  userManagement: function userManagement() {
    return import('@/views/system/userManagement');
  },
  // 用户管理
  invoiceManagement: function invoiceManagement() {
    return import('@/views/system/invoiceManagement');
  },
  // 发票管理
  noticeManagement: function noticeManagement() {
    return import('@/views/system/noticeManagement');
  },
  // 发票管理
  // messageReminding: () => import('@/views/system/messageReminding'), // 消息提醒
  operationLog: function operationLog() {
    return import('@/views/system/operationLog');
  },
  // 操作日志
  message: function message() {
    return import('@/views/system/message');
  }
};
// 审批管理路由对应组件
export var approveManageRouterComponents = {
  // approveList: () => import('@/views/approveManage/approveList'), // 审批管理
  // launchApproval: () => import('@/views/approveManage/launchApproval'), // 发起审批
  // processList: () => import('@/views/approveManage/processList'), // 自定义流程
  // theoryList: () => import('@/views/approveManage/theoryList') // 贵重仪器维修论证
};
// 工单管理路由对应组件
export var orderManageRouterComponents = {
  // launchRepair: () => import('@/views/orderManage/launchRepair'), // 发起维修单
  // inquiryList: () => import('@/views/orderManage/inquiryList'), // 询价管理
  // repairList: () => import('@/views/orderManage/repairList') // 维修单管理
};
// 工作台路由对应组件
export var workbench = {
  woker: function woker() {
    return import('@/views/workTable/worker');
  },
  // 工作台
  repairOrder: function repairOrder() {
    return import('@/views/workTable/repairOrder');
  },
  maintenanceOrder: function maintenanceOrder() {
    return import('@/views/workTable/maintenanceOrder');
  },
  approvalOrder: function approvalOrder() {
    return import('@/views/workTable/approvalOrder');
  },
  acceptanceOrder: function acceptanceOrder() {
    return import('@/views/workTable/acceptanceOrder');
  },
  settlementOrder: function settlementOrder() {
    return import('@/views/workTable/settlementOrder');
  },
  publicBidding: function publicBidding() {
    return import('@/views/workTable/publicBidding');
  },
  // 工作台
  settleSummary: function settleSummary() {
    return import('@/views/workTable/settleSummary');
  },
  // 结算汇总单
  // woker: () => import('@/views/workbench/woker'), // 工作台
  // afterSalesData: () => import('@/views/workbench/data') // 工作台
  maintenanceStatistics: function maintenanceStatistics() {
    return import('@/views/workTable/maintenanceStatistics');
  } // 维修费统计
};
// 财务管理对应组件
export var financialManagement = {
  // accountStatement: () => import('@/views/financialManagement/accountStatement'), // 对账单
  // settlementManagement: () => import('@/views/financialManagement/settlementManagement') // 结算管理
};
// 可视化数据对应组件
export var visualizeData = {
  college: function college() {
    return import('@/views/visualizeData/college');
  },
  // 院级统计
  // parts: () => import('@/views/visualizeData/parts'), // 配件统计
  repair: function repair() {
    return import('@/views/visualizeData/repair');
  },
  // 维修统计
  school: function school() {
    return import('@/views/visualizeData/school');
  },
  // 校级统计
  stoppage: function stoppage() {
    return import('@/views/visualizeData/stoppage');
  } // 故障统计
  // supplier: () => import('@/views/visualizeData/supplier') // 供应商统计
};

// 首页对应组件
export var homeData = {
  home: function home() {
    return import('@/views/homeData/home');
  } // 院级统计
};

// 学习专区对应组件
export var learningZone = {
  learning: function learning() {
    return import('@/views/learningZone/learning');
  },
  // 学习专区
  courseRegistration: function courseRegistration() {
    return import('@/views/learningZone/courseRegistration');
  },
  // 课程报名
  courseInfo: function courseInfo() {
    return import('@/views/learningZone/courseInfo');
  },
  // 课程信息
  myCollection: function myCollection() {
    return import('@/views/learningZone/myCollection');
  },
  // 我的收藏
  studyMaterial: function studyMaterial() {
    return import('@/views/learningZone/studyMaterial');
  }
};
export var safeInspection = {
  inspectionTask: function inspectionTask() {
    return import('@/views/safeInspection/inspectionTask');
  },
  // 巡检任务
  inspectionEquipment: function inspectionEquipment() {
    return import('@/views/safeInspection/inspectionEquipment');
  } // 巡检仪器
};
// 数据统计对应组件
export var dataStatistics = {
  billStatistics: function billStatistics() {
    return import('@/views/dataStatistics/billStatistic');
  },
  // 账单统计
  pdFundsManage: function pdFundsManage() {
    return import('@/views/dataStatistics/pdFundsManage');
  },
  // 实设处经费列表
  pdFundsDetailManage: function pdFundsDetailManage() {
    return import('@/views/dataStatistics/pdFundsDetailManage');
  } // 实设处经费明细列表
};

// 备件管理对应组件
export var sparePartsManage = {
  warehousingManage: function warehousingManage() {
    return import('@/views/sparePartsManage/warehousingManage');
  },
  // 入库管理
  sparePartsUse: function sparePartsUse() {
    return import('@/views/sparePartsManage/sparePartsUseManage');
  },
  // 领用单管理
  sparePartsInfo: function sparePartsInfo() {
    return import('@/views/sparePartsManage/sparePartsInfo');
  },
  // 基础资料--备件信息
  warehouseManage: function warehouseManage() {
    return import('@/views/sparePartsManage/warehouseManage');
  },
  // 基础资料--仓库管理
  positionManage: function positionManage() {
    return import('@/views/sparePartsManage/positionManage');
  },
  // 基础资料--仓位管理
  sourceUnit: function sourceUnit() {
    return import('@/views/sparePartsManage/sourceUnit');
  },
  // 基础资料--来源单位
  receivingUnit: function receivingUnit() {
    return import('@/views/sparePartsManage/receivingUnit');
  },
  // 基础资料--领用单位
  realTimeInventory: function realTimeInventory() {
    return import('@/views/sparePartsManage/realTimeInventory');
  },
  // 实时库存
  inventorySheet: function inventorySheet() {
    return import('@/views/sparePartsManage/inventorySheet');
  },
  // 盘点单
  stockTransferOrder: function stockTransferOrder() {
    return import('@/views/sparePartsManage/stockTransferOrder');
  } // 移库单
};

// 维保服务对应组件
export var maintenanceService = {
  maintenance: function maintenance() {
    return import('@/views/maintenanceService/maintenance');
  },
  // 维保服务
  maintenanceCollection: function maintenanceCollection() {
    return import('@/views/maintenanceService/maintenanceCollection');
  } // 我的收藏
};

// 租赁对应组件
export var leaseManage = {
  leaseDevice: function leaseDevice() {
    return import('@/views/leaseManage/leaseDevice');
  },
  // 仪器租赁
  myLeasefavorites: function myLeasefavorites() {
    return import('@/views/leaseManage/myLeasefavorites');
  } // 我的收藏
};
// 仪器推介
export var recommendManage = {
  recommend: function recommend() {
    return import('@/views/recommendManage/recommend');
  },
  // 仪器推介
  collectRecommend: function collectRecommend() {
    return import('@/views/recommendManage/collectRecommend');
  },
  // 我的收藏
  trialApplication: function trialApplication() {
    return import('@/views/recommendManage/trialApplication');
  } // 试用申请
};

// 仪器备件专区
export var instrumentSparePartsZone = {
  instrumentSpareparts: function instrumentSpareparts() {
    return import('@/views/instrumentSparePartsZone/instrumentSpareparts');
  },
  // 备件信息
  collectInstrumentSpareparts: function collectInstrumentSpareparts() {
    return import('@/views/instrumentSparePartsZone/collectInstrumentSpareparts');
  } // 我的收藏
};

// 资源专区
export var resourceManage = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, learningZone), leaseManage), recommendManage), maintenanceService), instrumentSparePartsZone);

// 公司演示环境独有菜单（动态添加到统一映射表）
if (!pro) {
  // 公司演示环境独有菜单
  systemManagementRouterComponents.partsManagement = function () {
    return import('@/views/system/partsManagement');
  };
} else if (pro == 'hainmc') {
  // 海医环境独有菜单
  systemManagementRouterComponents.partsManagement = function () {
    return import('@/views/system/partsManagement_hainmc');
  };
  systemManagementRouterComponents.maintenanceWorkOrder = function () {
    return import('@/views/system/maintenanceWorkOrder');
  };
}

// ==================== 统一组件映射表 ====================
// 将所有组件合并到一个对象中，通过 key 直接查找
export var dynamicComponents = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, supplierManagementRouterComponents), systemManagementRouterComponents), approveManageRouterComponents), orderManageRouterComponents), workbench), financialManagement), visualizeData), homeData), safeInspection), dataStatistics), sparePartsManage), resourceManage);
// 前端未找到页面路由（固定不用改）
var notFoundRouter = {
  path: '*',
  redirect: '/404',
  hidden: true
};

/**
 * 把静态路由地址匹配到对应的子项目数据中
 */
function AutoSetStaticRoutes(routes) {
  var permissionKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var arr = routes || constantRoutes;
  if (arr && Array.isArray(arr)) {
    var projects = store.state.permission.projects;
    arr.forEach(function (item) {
      var itemPermissionKey = item.permissionKey || permissionKey;
      if (itemPermissionKey) {
        var itemPath = path ? "".concat(path, "/").concat(item.path) : item.path;
        if (projects.some(function (sub) {
          if (itemPermissionKey === sub.permissionKey) {
            store.commit('permission/setProjectsAllRouters', {
              permissionKey: itemPermissionKey,
              path: itemPath
            });
            return true;
          }
        }) && item.children && Array.isArray(item.children)) {
          AutoSetStaticRoutes(item.children, itemPermissionKey, itemPath);
        }
      }
    });
  }
}

/**
 * 获取后端路由信息的 axios API
 * @returns {Promise}
 */
export var getRouterByUserApi = function getRouterByUserApi() {
  return service({
    url: '/ysa-system-service/system/permission/user',
    // url: '../../router/router.json',
    method: 'post',
    dataType: 'json'
  });
};

/**
 * 当前目录下所有菜单和按钮权限
 * @returns {Promise}
 */
export var getUserDirectory = function getUserDirectory(data) {
  return service({
    url: '/ysa-system-service/system/permission/userDirectory',
    method: 'post',
    datatype: 'json',
    headers: {
      'Content-Type': 'application/json;'
    },
    data: JSON.stringify(data)
  });
};

/**
 * 获取子项目菜单信息
 *
 * 1. 调用 getRouterByUser() 访问后端接口获得路由结构数组
 * 2. 调用
 * @returns {Promise<any>}
 */
// import res from '@/router/router.json'

export var getRouterByUser = function getRouterByUser() {
  return new Promise(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve, reject) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // if (res.data && Array.isArray(res.data) && res.data.length > 0) {
            //   store.commit('permission/setProjects', res.data)
            //   store.commit('permission/currPermissionKey',
            //     res.data[0].permissionKey || '')
            //   const routerComponents = [] // 路由原数据
            //   res.data.forEach((item) => {
            //     const permissionMS = item.permissionMS || []
            //     const rootMenu = getRootMenu([...permissionMS, item])
            //     const routers = generator(item.permissionKey, rootMenu[0].children)
            //       .filter((sub) => {
            //         if (sub) {
            //           return true
            //         }
            //       })
            //     routerComponents.push(routers)
            //   })
            //   routerComponents.push([notFoundRouter])

            //   let routers = []

            //   routerComponents.forEach((item) => {
            //     routers = routers.concat(item)
            //   })

            //   AutoSetStaticRoutes()

            //   resolve(routers)
            // }

            getRouterByUserApi().then(function (res) {
              if (res.data && Array.isArray(res.data) && res.data.length > 0) {
                store.commit('permission/setProjects', res.data);
                store.commit('permission/currPermissionKey', res.data[0].permissionKey || '');
                var routerComponents = []; // 路由原数据
                var allPermissionKey = [];
                var allbuttons = [];
                res.data.forEach(function (item) {
                  var permissionMS = item.permissionMS || [];
                  var rootMenu = getRootMenu([].concat(_toConsumableArray(permissionMS), [item]));
                  var routers = _generator(item.permissionKey, rootMenu).filter(function (sub) {
                    if (sub) {
                      return true;
                    }
                  });
                  routerComponents.push(routers);
                  allPermissionKey.push(item.permissionKey);
                  if (item.permissionMS) {
                    item.permissionMS.forEach(function (permission) {
                      allPermissionKey.push(permission.permissionKey);
                      allbuttons = [].concat(_toConsumableArray(allbuttons), _toConsumableArray(permission.buttons));
                    });
                  }
                  store.commit('permission/allPermissionKey', allPermissionKey || []);
                  store.commit('permission/allbuttons', allbuttons || []);
                });
                routerComponents.push([notFoundRouter]);
                var routers = [];
                routerComponents.forEach(function (item) {
                  routers = routers.concat(item);
                });
                AutoSetStaticRoutes();
                resolve(routers);
              }
            })["catch"](function (err) {
              reject(err);
            });
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};

/**
 * 格式化 后端 结构信息并递归生成层级路由表
 *
 * @param routerMap
 * @param parent
 * @returns {*}
 */
var _generator = function generator(permissionKey, routerMap, parent) {
  if (!routerMap) return [];
  return routerMap.map(function (item) {
    // 直接从统一组件映射表中根据 item.key 获取组件
    var component = dynamicComponents[item.key.trim()];
    if (!component && item.component === 'PageView') {
      // component = Layout
      if (!(parent && parent.hasLayout)) {
        item.hasLayout = true;
        component = Layout;
      } else {
        component = Layout2;
      }
    }
    if (component) {
      var currentRouter = {
        // 路由地址 动态拼接生成如 /dashboard/workplace
        path: item.path || "".concat(parent && parent.path || '', "/").concat(item.key),
        // 路由名称，建议唯一
        name: item.name || item.key || '',
        // 该路由对应页面的 组件 优先根据组件名或者key从constantRouterComponents获取，没有则通过组件名地址查询
        component: component,
        hideChildrenInMenu: item.hideChildrenInMenu || false,
        // meta: 页面标题, 菜单图标, 页面权限(供指令权限用，可去掉)
        meta: {
          // 所属项目
          permissionKey: permissionKey || '',
          title: item.title,
          icon: item.icon || undefined,
          hiddenHeaderContent: item.hiddenHeaderContent || false,
          target: item.target,
          buttons: item.buttons,
          affix: item.key === 'home'
        },
        alwaysShow: item.component === 'PageView',
        hasLayout: item.hasLayout
      };

      // 把路由地址添加到对应的子项目数据中
      store.commit('permission/setProjectsAllRouters', {
        permissionKey: permissionKey,
        path: currentRouter.path
      });

      // 隐藏菜单
      if (item.hidden) {
        currentRouter.hidden = true;
      }
      // 是否设置了隐藏子菜单
      if (item.hideChildrenInMenu) {
        currentRouter.hideChildrenInMenu = true;
      }
      // 为了防止出现后端返回结果不规范，处理有可能出现拼接出两个 反斜杠
      if (!currentRouter.path.startsWith('http')) {
        currentRouter.path = currentRouter.path.replace('//', '/');
      }
      // 重定向
      item.redirect && (currentRouter.redirect = item.redirect);
      // 是否有子菜单，并递归处理
      if (item.children && item.children.length > 0) {
        // Recursion
        currentRouter.children = _generator(permissionKey, item.children, currentRouter).filter(function (sub) {
          if (sub) {
            return true;
          }
        });
      }
      return currentRouter;
    } else {
      return false;
    }
  });
};
export { _generator as generator };
export function getRootMenu(rows) {
  // 根菜单
  var routeList = [];
  buildtree(rows, routeList, 0);
  return routeList;
}
export function buildtree(list, arr, parentId) {
  list.forEach(function (item) {
    if (item.parentId === parentId) {
      var child = {
        title: item.name,
        key: item.permissionKey || '',
        name: item.name | undefined,
        icon: item.icon,
        hidden: item.visible === '1',
        path: item.path && item.path.length > 0 ? item.path : undefined,
        component: item.component,
        redirect: item.redirect,
        target: item.target,
        hideChildrenInMenu: item.hiddenChildren,
        hiddenHeaderContent: item.hiddenHeader,
        buttons: item.buttons || [],
        children: []
      };
      buildtree(list, child.children, item.permissionId);
      if (child.children.length === 0) {
        delete child.children;
      }
      arr.push(child);
    }
  });
}